var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9637 17.8676H5.43375C2.66875 17.8676 1.75 16.0301 1.75 14.1838V6.81632C1.75 4.05132 2.66875 3.13257 5.43375 3.13257H10.9637C13.7287 3.13257 14.6475 4.05132 14.6475 6.81632V14.1838C14.6475 16.9488 13.72 17.8676 10.9637 17.8676Z",
    stroke: "#0877FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.08 14.9626L14.6475 13.2564V7.73512L17.08 6.02887C18.27 5.19762 19.25 5.70511 19.25 7.16636V13.8339C19.25 15.2951 18.27 15.8026 17.08 14.9626Z",
    stroke: "#0877FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 9.625C10.7874 9.625 11.375 9.03737 11.375 8.3125C11.375 7.58763 10.7874 7 10.0625 7C9.33763 7 8.75 7.58763 8.75 8.3125C8.75 9.03737 9.33763 9.625 10.0625 9.625Z",
    stroke: "#0877FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.feae80cf497ad6e5ec9453ba5b29db84.svg";
export { ForwardRef as ReactComponent };